import { render, staticRenderFns } from "./user.vue?vue&type=template&id=63cf28cf&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf28cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63cf28cf')) {
      api.createRecord('63cf28cf', component.options)
    } else {
      api.reload('63cf28cf', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=63cf28cf&scoped=true&", function () {
      api.rerender('63cf28cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user.vue"
export default component.exports